import React, { useEffect } from 'react';

interface PromptProps {
  when: boolean;
  message: string | (() => string);
}

const Prompt: React.FC<PromptProps> = ({ when, message }) => {
  // Prevent page unload (closing the tab or refreshing)
  useEffect(() => {
    if (!when) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const messageToDisplay = typeof message === 'function' ? message() : message;
      event.returnValue = messageToDisplay; // Standard for most browsers
      return messageToDisplay;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [when, message]);

  // Intercept navigation actions if 'when' is true
  useEffect(() => {
    if (!when) return;

    const handlePopState = (event: PopStateEvent) => {
      const messageToDisplay = typeof message === 'function' ? message() : message;
      const confirmed = window.confirm(messageToDisplay);

      if (!confirmed) {
        event.preventDefault(); // Prevent the navigation
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [when, message]);

  return null;
};

export default Prompt;
